import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakOn',
  standalone: true,
})
export class BreakOnPipe implements PipeTransform {
  /**
   * do not forget add class 'whitespace-pre-line'
   */
  transform(
    value: string,
    breakAt: string,
    position: 'before' | 'after' | 'both' = 'before',
    occurrence: number = 1,
  ): string {
    if (!value || !breakAt || occurrence < 1) return value;

    let index = -1;
    let fromIndex = 0;

    for (let i = 0; i < occurrence; i++) {
      index = value.indexOf(breakAt, fromIndex);
      if (index === -1) return value;
      fromIndex = index + breakAt.length;
    }

    const before = value.slice(0, index);
    const match = value.slice(index, index + breakAt.length);
    const after = value.slice(index + breakAt.length);

    switch (position) {
      case 'before':
        return `${before}\n${match}${after}`;
      case 'after':
        return `${before}${match}\n${after}`;
      case 'both':
        return `${before}\n${match}\n${after}`;
      default:
        return value;
    }
  }
}
